import angular from 'angular';

const countries = {
    AU: "Australia",
    NZ: "New Zealand",
    US: "U.S.",
    CA: "Canada",
    GB: "United Kingdom",
    // PAYL-8239 IM, JE and GG are Crown dependencies of the United Kingdom
    // They are still counted as countries in the system as they are valid ISO country codes
    IM: "Isle of Man",
    JE: "Jersey",
    GG: "Guernsey",
    HK: "Hong Kong",

    FR: "France",
    IT: "Italy",
    DE: "Germany",
    ES: "Spain"
};

// convert the backend order channel into the front presentation
export const Country = (countryCode) => countries[countryCode] || "Unknown"
export default Country

angular.module("core.application.main")
    .filter("core_application_main_filter_country", () => Country);
